// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../microservices/dash/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discussion-answered{max-height:50vh}.discussion-progress-bar{position:absolute!important;top:0;left:0;border-top-left-radius:2px;border-top-right-radius:2px}.discussion-comments-wrapper{overflow-y:auto}.load-more-button-wrapper{min-height:48px}", ""]);
// Exports
module.exports = exports;
